export default "__VITE_ASSET__BxvnDOJi__"